import { useRef, useEffect } from 'react';

// Read again when the page comes back to the front (tab switch, iPad wake),
// at most once a minute. The store has no RTK focus listeners, so pages that
// stay live (Rep Scoreboard) call this.
export const useRefetchOnFocus = (refetch: () => unknown, minGapMs = 60000) => {
  const last = useRef(Date.now());
  const latest = useRef(refetch);
  latest.current = refetch;
  useEffect(() => {
    const onFocus = () => {
      if (
        document.visibilityState === 'visible' &&
        Date.now() - last.current > minGapMs
      ) {
        last.current = Date.now();
        latest.current();
      }
    };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onFocus);
    return () => {
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onFocus);
    };
  }, [minGapMs]);
};
